import {
  UPDATE_STAGES,
  UPDATE_BROKER_GROSS,
  UPDATE_COLUMNS,
  SET_SAVING,
  SET_ERRORS,
  SET_SELECTED_STAGE,
  SET_NOTIFICATION,
  CLEAR_NOTIFICATION,
} from './actions';
import { defaultViewConfig } from '../config';

const initialState = {
  stages: {},
  view: {
    ...defaultViewConfig,
  },
  saving: false,
  errors: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case UPDATE_STAGES:
    return {
      ...state,
      stages: action.stages,
    };

  case UPDATE_BROKER_GROSS:
    return {
      ...state,
      view: {
        ...state.view,
        brokerGross: action.brokerGross,
      }
    };

  case UPDATE_COLUMNS: {
    return {
      ...state,
      columnOptions: {
        ...state.columnOptions,
        available: state.columnOptions.all.filter(option => !action.columns.includes(option.value)),
      },
      view: {
        ...state.view,
        columns: action.columns,
      }
    };
  }

  case SET_SELECTED_STAGE:
    return {
      ...state,
      selectedStage: action.stage,
    };

  case SET_SAVING:
    return {
      ...state,
      saving: action.saving,
    };

  case SET_ERRORS:
    return {
      ...state,
      errors: action.errors,
    };

  case SET_NOTIFICATION:
    return {
      ...state,
      notification: action.text,
    };

  case CLEAR_NOTIFICATION:
    return {
      ...state,
      notification: null,
    };

  default:
    return state;
  }
}
